import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import PanelBasic from '@adv-mt/mt-panel-basic/src/index.js'

const NO_OP = () => {}

const PANEL_CTA_BUTTON_WIDTH = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  FLEXIBLE: 'flexible'
}

const PANEL_CTA_BUTTON_POSITION = {
  BOTTOM: 'bottom',
  CENTER: 'center',
  TOP: 'top'
}

export default function PanelCta({panelBasicProps = {}, title, description, nodeFooter, cta = {}}) {
  const {
    atomButtonProps = {},
    href,
    nodeFooter: ctaNodeFooter,
    onClick: onCtaClick = NO_OP,
    text: ctaText,
    position: ctaPosition = PANEL_CTA_BUTTON_POSITION.TOP,
    width: ctaWidth = PANEL_CTA_BUTTON_WIDTH.FLEXIBLE
  } = cta
  const BASE_CLASS = 'mt-PanelCta'
  const RIGHT_CONTENT_CLASS = `${BASE_CLASS}-rightContent`
  const CTA_CLASS = `${RIGHT_CONTENT_CLASS}Cta`
  const mainContainerClassNames = cx(BASE_CLASS, {
    [`${BASE_CLASS}--cta-size-${ctaWidth}`]: ctaWidth
  })

  const buttonProps = {
    design: atomButtonDesigns.OUTLINE,
    shape: atomButtonShapes.CIRCULAR,
    ...atomButtonProps,
    ...(href && {href, link: true, target: '_blank'}),
    ...(ctaPosition && {className: cx(CTA_CLASS, `${CTA_CLASS}--position-${ctaPosition}`)})
  }

  return (
    <PanelBasic {...panelBasicProps}>
      <div className={mainContainerClassNames}>
        <article className="mt-PanelCta-leftContent">
          <header>
            <h3 className="mt-PanelCta-title">{title}</h3>
          </header>
          <p>{description}</p>
        </article>
        <div className={RIGHT_CONTENT_CLASS}>
          <AtomButton {...buttonProps} onClick={onCtaClick}>
            {ctaText}
          </AtomButton>
          {ctaNodeFooter && <>{ctaNodeFooter}</>}
        </div>
        {nodeFooter && <div>{nodeFooter}</div>}
      </div>
    </PanelBasic>
  )
}

export {PANEL_CTA_BUTTON_WIDTH as panelCtaButtonWidth}
export {PANEL_CTA_BUTTON_POSITION as panelCtaButtonPosition}

PanelCta.displayName = 'PanelCta'
PanelCta.propTypes = {
  panelBasicProps: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  cta: PropTypes.shape({
    href: PropTypes.string,
    nodeFooter: PropTypes.node,
    onClick: PropTypes.func,
    position: PropTypes.string,
    text: PropTypes.string,
    width: PropTypes.string
  }),
  nodeFooter: PropTypes.node,
  atomButtonProps: PropTypes.object
}
